import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import UserForm from './components/UserForm';
import Dashboard from './components/Dashboard';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import LogoutPage from './components/LogoutPage';
import './App.css';

function AppRoutes() {
  const { user, showUserForm, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <Routes>
      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      
      {/* Public Routes - /logout NO está aquí, está fuera de AuthProvider en App */}
      <Route 
        path="/login" 
        element={
          user ? <Login /> : <Login />
        } 
      />
      
      {/* User Form Route */}
      <Route 
        path="/complete-profile" 
        element={
          <ProtectedRoute>
            {showUserForm ? <UserForm /> : <Navigate to="/dashboard" replace />}
          </ProtectedRoute>
        } 
      />
      
      {/* Protected Routes */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            {showUserForm ? <Navigate to="/complete-profile" replace /> : <Dashboard />}
          </ProtectedRoute>
        } 
      />
      
      {/* Default Route */}
      <Route 
        path="/" 
        element={
          user ? (
            showUserForm ? <Navigate to="/complete-profile" replace /> : <Navigate to="/dashboard" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        } 
      />
      
      {/* 404 Route */}
      <Route 
        path="*" 
        element={
          <div className="error-page">
            <h1>404 - Página no encontrada</h1>
            <p>La página que buscas no existe.</p>
            <button onClick={() => window.location.href = '/'}>
              Ir al inicio
            </button>
          </div>
        } 
      />
    </Routes>
  );
}

const routerFutureFlags = {
  v7_startTransition: true,
  v7_relativeSplatPath: true
};

function App() {
  return (
    <Router future={routerFutureFlags}>
      <Routes>
        {/* /logout fuera de AuthProvider: así onAuthStateChanged no corre y no se llama setSession antes del signOut */}
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="*" element={
          <AuthProvider>
            <div className="App">
              <AppRoutes />
            </div>
          </AuthProvider>
        } />
      </Routes>
    </Router>
  );
}

export default App; 